// RSR 4-Point System (fabric inspection) — shared between the Deroi dispatch
// form (Procurement) and the RSR review screen (Quality → Raw Material Inward).

export const DEFECT_TYPES = ['HOLES', 'YARN PULLING', 'NEEDLE DROP', 'PATTA / V-LINE', 'CRUSH MARK', 'COLOR SPOT', 'OIL SPOT', 'SHEEN', 'RAISING / GOLI', 'WATER MARK', 'DIRT SPOT', 'OTHERS'];

// Point rules: HOLES 0-1"=2pts, >1"=4pts; all others 0-3"=1, 3-6"=2, 6-9"=3, >9"=4.
export const POINT_RULES = 'Points: HOLES 0–1″ = 2 pts, >1″ = 4 pts · All other defects: 0–3″ = 1, 3–6″ = 2, 6–9″ = 3, >9″ = 4 pts';

export const rollPoints = (roll) => DEFECT_TYPES.reduce((s, d) => s + (parseFloat(roll.defects?.[d]) || 0), 0);

// Grade bands per RSR format: A (20-30) / B (30-40) / C (40-50) / D (>50).
export const pointsGrade = (pts) => pts <= 30 ? 'A' : pts <= 40 ? 'B' : pts <= 50 ? 'C' : 'D';

export const GRADE_COLOR = { A: '#166534', B: '#0891b2', C: '#9A6B00', D: '#A32D2D' };

// ─── WHICH OF THE TWO GRADES COUNTS ─────────────────────────────────────────────────────
// Mirrors src/shared/fourPointGrade.js. A dispatch carries the seller's declared final_grade
// and the computed_final_grade derived from its own rolls; gates take the WORSE of the two.
// Declaring worse than computed is a legitimate disclosure (4-point does not see shade,
// barré, width or GSM), so it is kept and acted on. Declaring better contradicts the seller's
// own numbers and never wins.
export const GRADE_ORDER = ['A', 'B', 'C', 'D'];
const gradeRank = (g) => GRADE_ORDER.indexOf(String(g || '').toUpperCase());
export const worseGrade = (a, b) => {
  const ra = gradeRank(a), rb = gradeRank(b);
  if (ra < 0) return rb < 0 ? null : GRADE_ORDER[rb];
  if (rb < 0) return GRADE_ORDER[ra];
  return GRADE_ORDER[Math.max(ra, rb)];
};
export const effectiveGrade = (rep) => worseGrade((rep || {}).final_grade, (rep || {}).computed_final_grade);
